import React from "react";
import { TableCell, TableRow } from "@mui/material";

import BoxGrid from "../boxGrid/boxGrid";

import * as S from "./styles";

interface IOptionElement {
	content: string | React.ReactNode;
	width?: string | number;
}

export type IOptionGridMultiline = {
	id: string | number;
	elements: IOptionElement[];
};

interface IKogBoxGridMultiline {
	rowHeaders: string[] | React.ReactNode[];
	options: IOptionGridMultiline[];
	onClickCustom?: (option: IOptionGridMultiline, event: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => void;
	typeGrid?: "oddEven" | "default" | "backgroundHeader";
	sizeCell?: "small" | "medium" | "large";
}
function KogBoxGridMultiline({
	options,
	rowHeaders,
	onClickCustom = () => {},
	typeGrid = "default",
	sizeCell = "large",
}: IKogBoxGridMultiline) {
	return (
		<S.StyledBoxGrid>
			<BoxGrid typeGrid={typeGrid} sizeCell={sizeCell} rowHeaders={rowHeaders}>
				{options.map((option) => (
					<TableRow key={option.id} onClick={(e) => onClickCustom(option, e)}>
						{option.elements.map((item, index) => (
							<TableCell key={`${option.id}-${index}`} width={item.width}>
								<S.BaseTableCellGridMultiline>
									{Array.isArray(item.content) ? (
										item.content.map((element, indexElement) => {
											if (element.id) {
												return (
													<S.ItemGrid sizeCell={sizeCell} key={`indexElement-${index}-${element.id}`}>
														{element.content}
													</S.ItemGrid>
												);
											}
											return (
												<S.ItemGrid sizeCell={sizeCell} key={`indexElement-${index}-${indexElement}`}>
													{element}
												</S.ItemGrid>
											);
										})
									) : (
										<S.ItemGrid sizeCell={sizeCell}>{item.content}</S.ItemGrid>
									)}
								</S.BaseTableCellGridMultiline>
							</TableCell>
						))}
					</TableRow>
				))}
			</BoxGrid>
		</S.StyledBoxGrid>
	);
}

export default KogBoxGridMultiline;
